const completedAttendedTransferSessionIds = new Set<string>()

export const markAttendedTransferCompleted = (sessionId: string) => {
  completedAttendedTransferSessionIds.add(sessionId)
}

export const consumeAttendedTransferCompleted = (sessionId: string) => {
  if (!completedAttendedTransferSessionIds.has(sessionId)) return false
  completedAttendedTransferSessionIds.delete(sessionId)
  return true
}
